






























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { REG } from '@/config/validate.config'
import {
  getOrganizationTree,
  getPositionTree,
  getOrgRole,
  getOrganizationDetail,
  getPositionDetail,
  addRoleList,
  getRoleDetail,
} from '@/api/system'
@Component({
  name: 'AddOrgModal',
  data() {
    return {
      form: this.$form.createForm(this),
    }
  },
})
export default class AddBasicModal extends Vue {
  @Prop({ type: String }) readonly SelectTreeItem!: string;

  @Prop({ type: String }) readonly SelectPostTreeItem!: string;

  @Prop({ type: Number }) readonly status!: number;

  @Prop() readonly id?: string | undefined;

  @Prop() readonly activeKey!: number | string;

  @Prop({ type: Boolean }) readonly visible!: number;

  @Prop({ type: Array }) orgRoleList!: [];

  private REG: any = REG;

  private form: any;

  private readonly password: string = '123456';

  private spinning: boolean = false;

  private formItemLayout: any = {
    labelCol: { span: 6 },
    wrapperCol: { span: 17 },
  };

  private treeData: any = [];
  private gData: any[] = [];
  private postData: any[] = [];
  private roleList: any[] = [];
  private confirmLoading:Boolean = false
  private detailMap: any = {};
  roleId: any;

  get title() {
    return this.status === 1 ? '创建用户' : '编辑用户'
  }
  private async getRoleDetail() {
    try {
      const { data } = await getOrganizationDetail(this.SelectTreeItem)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          orgId: data.id,
          dataAuth: data.dataAuth? data.dataAuth
            : 0,
        })
      })
    } catch (error:any) {
      throw new Error(error.message)
    }
  }

  private changePwd() {
    this.form.setFieldsValue({
      password: '',
    })
  }

  private async getPosiDetail() {
    try {
      const { data } = await getPositionDetail(this.SelectPostTreeItem)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          positionId: data.id,
          dataAuth:data.dataAuth?data.dataAuth:'0'
        })
      })
    } catch (error:any) {
      throw new Error(error.message)
    }
  }

  public created() {
    this.roleList = this.orgRoleList.filter((item: any) => !item.roleCode)
    this.detailMap = {}
    this.getOrgTree()
    this.getPoiTree()
    if (!this.id) {
      if (Number(this.activeKey) === 1 && this.SelectTreeItem) {
        this.getRoleDetail()
      } else {
        if (this.SelectPostTreeItem) {
          this.getPosiDetail()
        }
      }
    }
    if (this.id) {
      this.getListDetail()
    }
  }
  /**递归获取职位或者组织名称 */
  public userPost (data:any,id:string):void {
    for(var item of data) {
      if(item.id === id) {
        return item.positionName || item.orgName
      } else {
        if (item.children.length > 0) {
          return this.userPost(item.children,id)
        }
      }
    }
  }
  public handleOk(): void {

  
    this.form.validateFields({ force: true }, (err: any, values: any) => {
      if (!err) {
          this.confirmLoading = true
        values.userStatus = 1
        const params = {...values}
        const msg: string = this.status === 1 ? '添加成功' : '编辑成功'
        params.positionName = this.userPost(this.postData,values.positionId)
        params.orgName = this.userPost(this.gData,values.orgId)
        if (this.status === 2) {
          const pwd: string = this.form.getFieldValue('password')
          if (pwd === this.password) {
            params.password = ''
          }
          params.id = this.id
        }
        addRoleList(params).then((res: any) => {
          if (res && res.status === 0) {
            this.$message.success(msg)
            
          } else {
            this.$notification.error({
              message: '错误',
              description: res.message,
            })
          }
           
          setTimeout(() => {

            this.$emit('update:visible', false)
            this.$emit('closeModal3')
             this.confirmLoading = false
          }, 500)
        }).catch(error => {
            this.confirmLoading = false
          this.$notification.error({
            message: '错误',
            description: error.message,
          })
        })
      }
      
    })
  }

  private async getListDetail() {
    this.spinning = true
    try {
      const { data } = await getRoleDetail(this.id)
      this.roleId = data.roleId
      this.form.setFieldsValue({
        userName: data.userName,
        realName: data.realName,
        positionName:data.positionName,
        orgName:data.orgName,
        password: this.password,
        positionId: data.positionId,
        lawEnforcementNumber:data.lawEnforcementNumber,
        dataAuth:data.dataAuth,
        orgId: data.orgId,
        phone: data.phone,
      })
      this.detailMap = data
      this.getRoleList()
    } catch (error:any) {
      throw new Error(error.message)
    }
     this.spinning = false
  }

  // 获取组织树

  private getOrgTree() {
    getOrganizationTree().then((res: any) => {
      if (res && res.status === 0) {
        this.gData = [res.data]
      }
    })
  }

  // 获取职位树

  private getPoiTree() {
    getPositionTree().then((res: any) => {
      if (res && res.status === 0) {
        this.postData = [res.data]
      }
    })
  }

  private async getRoleList() {
      if (this.status === 1) {
        this.roleList = this.orgRoleList.filter((item: any) => !item.roleCode)
      } else {
        if (!this.detailMap.roleCode) {
          this.roleList = this.orgRoleList.filter((item: any) => !item.roleCode)
        } else if(this.detailMap.roleCode === 'ROLE_QY_CLIENT_DEFAULT'){
          this.roleList = this.orgRoleList.filter((item: any) => !item.roleCode)
          this.form.setFieldsValue({
            roleId: undefined
          })
        } else {
          this.roleList = this.orgRoleList
        }
      }
  }

  public handleCancel(): void {
    this.$emit('update:visible', false)
  }
}
